import {Http} from "@/core/service/http.init";
import {roomEventApi} from "@/core/api/room.event.api";
import {} from "@/core/api/util.api.js";

export class BaseApi {
    #ready = false;
    #readyEvent;
    data = {};
    constructor() {
        this.#readyEvent = this.constructor.name + '_ready_' + Date.now()
    }

    getClassName() {
        return this.constructor.name;
    }

    // TODO 상속 class 판단
    isCurrentClass(clazz) {
        let chk = clazz.name === this.constructor.name;
        return chk;
    }

    ready(callback) {
        if (!this.#ready) {
            roomEventApi.addEventListener(this.#readyEvent, callback, {once: true})
            return
        }
        callback({client: this})
    }
    async _readyComplete() {
        this.#ready = true;
        await roomEventApi.trigger(this.#readyEvent, {})
    }

    request (status = { auth: true }) {
        return new Http(status)
    }

    _eventListen(listeners, instance=this) {
        roomEventApi.addEventListeners(listeners, instance);
    }
}

